import * as ko from "knockout";
import {Abstract} from "./Abstract";
import {
    ICondition,
    IRouteDefinitionParams,
    IRule,
    IRuleset,
    ITableColumn,
    TBaseOrObservableType,
} from "../../../index";
import {ObjectTypeId, TEXT_WRAPPER_START} from "../../../constants";
import {nsRuleset} from "../nsRuleset";
import {global, lm} from "../../../appContext";
import {nsRule} from "../mutable/rule/nsRule";
import {storeObservable} from "../../../util/sessionstore";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import getCondition = nsRuleset.getCondition;
import getDateRangeHumanReadable = nsRuleset.getDateRangeHumanReadable;
import rulesHtml from './rules.html?raw';

export let template = rulesHtml;

interface IParams extends IRouteDefinitionParams {
    ruleset: TBaseOrObservableType<IRuleset>
}

export class viewModel extends Abstract {
    private conditions!: ICondition[];
    private readonly asc: KnockoutObservable<boolean> = ko.observable(true);
    private readonly reqGetConditions = global.getPromiseRequest("getconditions");
    private readonly sortcol: KnockoutObservable<string> = ko.observable("order");
    private readonly toggleDerivedValues: KnockoutObservable<boolean> = storeObservable("ruleset.toggle.derived", true);
    private readonly rulesTableColumns: ITableColumn[] = [
        {key: "id"},
        {label: "logical operator", key: "booleanoperator"},
        {key: "attribute", binding: true},
        {label: "condition", key: "argumentoperator", getContent: (o: IRule) => lm.t('condition.' + o.argumentoperator) ?? ''},
        {key: "argument", binding: true},
        {
            label: "derived value",
            key: "derived",
            sort: false,
            binding: true,
            component: obj => {
                return {
                    name: 'component/ruleset/derived/details',
                    params: {
                        rule: obj,
                        ruleset: this.ruleset ?? this.data,
                        conditions: this.conditions,
                    }}
            },
            validator: () => this.toggleDerivedValues(),
        },
        {label: "Order", key: "order", sort: true},
    ];
    private ruleset: TBaseOrObservableType<IRuleset>;

    constructor(params: IParams) {
        super(params);
        this.ruleset = params.ruleset
    }

    protected override initRequest(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return Promise.resolve()
            .then(() => this.reqGetConditions
                .request()
                .then((data: ICondition[]) => this.conditions = data)
            )
            .then(super.initRequest.bind(this));
    }

    private getCellContent(key: string, val: any, item: IRule): string | number | any[] {
        switch (key) {
            case 'attribute':
                if (typeof val == 'string' && !val.startsWith(TEXT_WRAPPER_START)) {
                    return `<div data-bind="_component: {name: 'component/variable/syncfield-name', params: {key: '${val}', objecttypeid: [${this.data.objecttype.id}, ${ObjectTypeId.History}]}}" class="attribute-content"></div>`
                } else {
                    return `<div class="attribute-content"><span>${val}</span></div>`
                }
            case "argument":
                const condition = getCondition(item.argumentoperator, this.conditions);
                if (!condition) {
                    break;
                }
                switch (condition.type) {
                    case "ruleset":
                        return `<span data-bind="_component: {
                            name: 'component/variable/ruleset',
                            params: {id: ${item.argument}, linkable: true, showIcon: true},
                        }"></span>`;
                    case "array":
                        return nsRule.parseArrayArgument(val).join(',')
                    case "datetime":
                        return getDateRangeHumanReadable(val) ?? val;
                    default:
                        break;
                }
                break
        }
        return val;
    }

    private getCellText(key: string, val: any, item: IRule): string | number | any[] {
        switch (key) {
            case 'attribute':
                return val;
        }
        return val;
    }

    override dispose() {
        super.dispose();
        this.reqGetConditions.abort();
    }
}
